class Logger {
    error(message, options = {}) {
        console.error('Message: %O\nTags: %O\nContext: %O\n', {
            message
        }, options.tags, options.context);
    }
}
export { Logger };
